import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp } from 'lucide-react';
import "./style.css";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	const footerLinks = [
		{ name: "Home-", href: "/" },
		{ name: "Services-", href: "/#services" },
		{ name: "About-", href: "/#about" },
		{ name: "Portfolio-", href: "/portfolio" },
		{ name: "Contact", href: "/contact" },
	];

	return (
		<footer className="footer-section">
			<span className="footer-top-gradient" />
			<div className="footer-container">
				<div className="footer-main-row">
					<div>
						<div className="footer-brand-wrapper">
							{/* <span className="footer-logo-box">
								<span className="footer-logo-inner" />
							</span> */}
							<img src="/assets/images/halfWhiteLogoNoBG.png" alt="Moonface Techs Logo" className="nav-logo" />
							<span className="footer-brand-text">
								Moonface <span className="title-gradient">Techs</span>
							</span>
						</div>
						<p className="footer-subtitle">
							ReactJS Web Development Solutions
						</p>
					</div>

					<nav className="footer-links-wrapper">
						{footerLinks.map((link) => (
							link.href.startsWith("/#") ? (
								<a
									key={link.name}
									href={link.href}
									className="footer-link"
								>
									{link.name}  
								</a>
							) : (
								<Link
									key={link.name}
									to={link.href}
									className="footer-link"
								>
									{link.name}
								</Link>
							)
						))}
					</nav>

					<a
						href="#home"
						aria-label="Back to top"
						className="footer-back-to-top"
					>
						<ArrowUp className="footer-arrow-icon" />
					</a>
				</div>

				<div className="footer-bottom-row">
					<p className="footer-copyright">
						© {currentYear} Moonface Techs. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;